export default "__VITE_ASSET__3a7df4e7__"